import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { AlertController, IonRouterOutlet, ModalController } from '@ionic/angular';
import { BackendService } from '../../core/services/backend-prod.service';
import { HelperService } from '../../core/services/helper.service';
import { Storage } from '@ionic/storage';
import { IonInfiniteScroll } from '@ionic/angular';
import { MatSort, Sort } from '@angular/material/sort';
import { BehaviorSubject, Subject, Subscription, fromEvent, interval } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { MenuService } from 'src/app/core/services/menu.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogBoxComponent } from 'src/app/shared/components/dialog-box/dialog-box.component';
import { environment } from 'src/environments/environment';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { SelectionModel } from '@angular/cdk/collections';
import { HttpClient } from '@angular/common/http';
// import { getServiceStatus } from 'src/streaminglogs.js';
// import { LiveStreamLogsComponent } from 'src/app/shared/modals/live-stream-logs/live-stream-logs.component';

@Component({
  selector: 'app-integration-bridge',
  templateUrl: './integration-bridge.component.html',
  styleUrls: ['./integration-bridge.component.scss'],
})
export class IntegrationBridgeComponent implements OnInit, OnDestroy {
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  private incomingSearchText$ = new BehaviorSubject('');

  breadcrumbList = [
    {
      label: 'Integration',
      embedurl: true,
      url: '/baseapp/integration/list',
    },
    {
      label: 'List',
      embedurl: false,
      url: '',
    },
  ];

  integrationDisplayedColumns: string[] = [
    'ic_name',
    'source_name',
    'target_name',
    'source_type',
    'target_type',
    'updated_date',
    'updated_by',
    'status',
    'select',
    'action',
  ];
  integrationDataSource = [];
  hide1200 = false;
  page_min = 0;
  page_max = 10;
  totalIntegration = 0;
  sortBy: string = '';
  orderBy: string = 'DESC';
  updatedDate_sortBy: string = '';
  updatedDate_orderBy: string = 'DESC';
  search = '';
  loading = true;
  resultdata: any;
  bubbleshow: boolean = false;
  bubbly: number;
  service_status;
  ibEditEnable = false;
  ibDeleteEnable = false;
  ibDetailsEnable = false;
  ibAddEnable = false;
  ibStartEnable = false;
  ibStopEnable = false;
  isStreamingLogsEnabled = false;
  isDownloadLogsEnabled = false;
  freeTrailMode;
  currentState: string;
  importAndExportIBEnableFromENV: boolean;
  ibselection = new SelectionModel<any>(true, []);
  importFile: any;
  runOnce_feat:boolean;
  roleId;
  selectExportAllIB:boolean=false;
  selectedIB=[];
  // private wsData: any[] = [];
  // private intervalSubscription: Subscription;
  constructor(
    public breakpointObserver: BreakpointObserver,
    private backendService: BackendService,
    public menuService: MenuService,
    private router: Router,
    public storage: Storage,
    public alertController: AlertController,
    public helperService: HelperService,
    private dialog: MatDialog,
    private modalCtrl: ModalController,
    private domSanitizer: DomSanitizer,
    private http:HttpClient
  ) { }

  ngAfterViewInit() {
    this.sort.sortChange.subscribe((e) => {
      if (this.currentState == 'status') {
        this.orderBy = e.direction.toUpperCase();
      }
      // this.orderBy = e.direction.toUpperCase();
      // this.helperService.loader();
      // this.getAllIntegration();
    });
  }
  
  ngOnInit() {
      this.http.get('assets/feature_switching.json').subscribe((res: any) => {
        this.runOnce_feat=res.runonce;
        this.importAndExportIBEnableFromENV = res.importAndExportEnableFromENV;
      });

    this.helperService.getNavHelp().subscribe(toggle => {
      if (toggle) {
        this.closebubblecross();
      }
    });
    this.getAllIntegration();
    // this.helperService.loader();
    this.incomingSearchText$.pipe(debounceTime(500)).subscribe((value) => {
      this.search = value;
      this.searchIntegration();
    });
    this.breakpointObserver
      .observe(['(min-width: 1200px)'])
      .subscribe((state: BreakpointState) => {
        if (state.matches) this.hide1200 = true;
        else this.hide1200 = false;
      });

    this.getStorage().then((res) => {
      if (res.showDialog == 1) this.bubbleshow = true;
      else this.bubbleshow = false;
    })
    this.menuService.decodeToken().then(res => {
      this.roleId = res.role.role_id;
      let permissions = res.permissions;
      permissions.map((e) => {
        if (e.perm_mod == 'IB_ADD') this.ibAddEnable = true;
        if (e.perm_mod == 'IB_EDIT') this.ibEditEnable = true;
        if (e.perm_mod == 'IB_DETAILS') this.ibDetailsEnable = true;
        if (e.perm_mod == 'IB_DELETE') this.ibDeleteEnable = true;
        if (e.perm_mod == 'IB_START_SERVICE') {
          this.ibStartEnable = true;
          this.ibStopEnable = true;
        }
        if (e.perm_mod == 'IB_STREAMING_LOGS'){
          this.http.get('assets/feature_switching.json').subscribe((res: any) => {
            this.isStreamingLogsEnabled = res.streaming_logs;
          });
        } 
        if (e.perm_mod == 'IB_DOWNLOAD_LOGS'){
          this.http.get('assets/feature_switching.json').subscribe((res: any) => {
            this.isDownloadLogsEnabled = res.download_logs;
          });
        }
      })
    });
    // this.isStreamingLogsEnabled = environment.enable_streaming_logs_icon;
    // this.getInstanceDetails();
    
    // fromEvent(window, 'ib-service-status').subscribe((data) => {
    //     if(data["detail"]['status_code'] != undefined){
    //       this.wsData.push(data['detail']['ib_id']);
    //       this.integrationDataSource.find(v => {
    //         if(v.id === data["detail"]['ib_id'] && data["detail"]['status_code'] === 1){
    //           v.service_status = 1;
    //         }else{
    //           if(!this.wsData.includes(v.id)){
    //             v.service_status = 0;
    //           }
    //         }
    //       })
    //     }    
    // })
  }

  async confirmDeleteAlert(header, msg, userId) {
    const alert = await this.alertController.create({
      header: header,
      message: msg,
      buttons: [
        {
          text: 'CANCEL',
          cssClass: 'primary-text',
          handler: () => {
            alert.dismiss();
          },
        },
        {
          text: 'OK',
          cssClass: 'primary-text',
          handler: () => {
            this.deleteIntegration(userId);
          },
        },
      ],
    });
    await alert.present();
  }

  searchIntegration() {
    this.getStorage().then((res) => {
      let payload = {
        min: this.page_min,
        max: this.page_max,
        sort: this.sortBy,
        order: this.orderBy,
        updatedDate_sort: this.updatedDate_sortBy,
        updatedDate_order: this.updatedDate_orderBy,
        q: this.search,
      };
      this.backendService
        .PostAPICall('getAllIntBridge', payload, res.token)
        .subscribe(
          async (data) => {
            this.helperService.closeLoader();
            if(data.records.length > 0){
              await this.helperService.decryptpayload(data.records).then((res)=>{
                this.integrationDataSource = JSON.parse(res)
              });
              this.totalIntegration = data.total_count;
            }else{
              this.integrationDataSource = [];
            }
            this.totalIntegration = data.total_count;
            // for(let i of this.wsData){
            //   this.integrationDataSource.find(v => {
            //     if(v.id === i.ib_id && v.service_status !== i.data){
            //       v.service_status = i.data;
            //     }
            //   })
            // }
          },
          (error) => {
            //console.log(error);
            this.helperService.closeLoader();
            this.helperService.presentToast(error.error.detail, 2000);
          }
        );
    });
  }


  async confirmCopyIBAlert(header, msg, element) {
    const alert = await this.alertController.create({
      header: header,
      message: msg,
      buttons: [
        {
          text: 'NO',
          cssClass: 'primary-text',
          handler: () => {
            alert.dismiss();
          },
        },
        {
          text: 'YES',
          cssClass: 'primary-text',
          handler: () => {
            this.showPrompt(element)
          },
        },
      ],
    });
    await alert.present();
  }

  copyIBDetailsAPI(element, intBridgeName) {
    this.getStorage().then((res) => {
      let payload = {
        id: element.id,
        integration_bridge_name: intBridgeName,
        created_by: res.userId,
        created_ip_address: element.created_ip_address
      };
      this.backendService
        .PostAPICall('copyIntBridge', payload, res.token)
        .subscribe(
          (data) => {
            this.helperService.presentToast(data.msg, 2000);
            this.getAllIntegration();
          },
          (error) => {
            //console.log(error);
            this.loading = false;
            this.helperService.handleError(error);
          }
        );
    });
  }

  confirmCopyIB(element) {
    const header = 'Confirm!';
    const msg = 'Are you sure you want to copy?';
    this.confirmCopyIBAlert(header, msg, element);
  }

  showPrompt(element): void {
    const dialogRef = this.dialog.open(DialogBoxComponent, {
      width: '500px',
      height: '255px',
    });

    dialogRef.afterClosed().subscribe((data) => {
      if (data.clicked === 'submit') {
        this.copyIBDetailsAPI(element, data.form.name)
      }
    });
  }

  async showRefreshServiceAlert(id) {
    const alert = await this.alertController.create({
      header: 'Confirm!',
      message: 'Are you sure you want to Refresh the Integration Service?',
      buttons: [
        {
          text: 'NO',
          cssClass: 'primary-text',
          handler: () => {
            alert.dismiss();
          },
        },
        {
          text: 'YES',
          cssClass: 'primary-text',
          handler: () => {
            this.refreshService(id)
          },
        },
      ],
    });
    await alert.present();
  }

  getAllIntegration(resetSort?) {
    this.getStorage().then(async(res) => {
      await this.helperService.loader();
      this.freeTrailMode = res.freeTrailMode;
      //console.log(resetSort)
      //console.log(this.orderBy)
      if (resetSort) {
        this.sortBy = '';
        this.orderBy = 'DESC';
        this.updatedDate_sortBy = '';
        this.updatedDate_orderBy = 'DESC';
      }
      let payload = {
        min: this.page_min,
        max: this.page_max,
        sort: this.sortBy,
        order: this.orderBy,
        updatedDate_sort: this.updatedDate_sortBy,
        updatedDate_order: this.updatedDate_orderBy,
        q: this.search,
      };



      this.backendService
        .PostAPICall('getAllIntBridge', payload, res.token)
        .subscribe(
          async (data) => {
            this.helperService.closeLoader();
            if(data.records.length > 0){
              await this.helperService.decryptpayload(data.records).then((res)=>{
                this.integrationDataSource = JSON.parse(res);
              });
              this.totalIntegration = data.total_count;
            }else{
              this.integrationDataSource = [];
              this.totalIntegration = data.total_count;
            }
            
            this.ibselection.clear();
            this.selectedIB = [];
            this.loading = false;
            // for(let i of this.wsData){
            //   this.integrationDataSource.find(v => {
            //     if(v.id === i.ib_id && v.service_status !== i.data){
            //       v.service_status = i.data;
            //     }
            //   })
            // }
          },
          (error) => {
            //console.log(error);
            this.loading = false;
            this.helperService.closeLoader();
            this.helperService.handleError(error);
          }
        );
    });
  }

  startService(id, py_conf_filename) {
    this.getStorage().then(async (res) => { 
    await this.helperService.loader();
      let payload = {
        serviceFileName: py_conf_filename + '.service',
        id
      };
      this.backendService
        .PostAPICall('startService', payload, res.token)
        .subscribe(
          (data) => {
            this.service_status = data.statusCode;
            let obj = { id: id, status: "Start" };
            this.helperService.store("status", obj);
            this.getAllIntegration();
            this.helperService.presentAlert("Alert!", data.msg);
            this.helperService.closeLoader();
          },
          (error) => {
            //console.log(error);
            this.loading = false;
            this.helperService.closeLoader();
            this.helperService.handleError(error);
          }
        );
    });
  }
  runOnce(id) {
    this.helperService.loader();
    this.getBridgeDetails(id).then((res)=>{
      let payload=res
      this.generateToken().then((token)=>{
          let url = environment.python_api_base_url + "/Runonce/app"
          this.backendService.PostMilestoneAPICall(url, payload, token).subscribe(
            (data) => {
              const parser=new DOMParser()
              let dataHtml=parser.parseFromString(data.body, 'text/html');
              let rows=dataHtml.getElementsByTagName('pre');
              let finalData=[];
              for(let row of rows){
                finalData.push(JSON.parse(row.textContent))
              }
              if(finalData[0]?.bizdata_dataset_status==200){
                this.helperService.presentToast('Service started successfully for one-time execution',2000);
                this.helperService.closeLoader();
              }
              else{
                this.helperService.presentToast("Source is not configured correctly",2000);
                this.helperService.closeLoader();
              }
              },
              (error) => {
                this.helperService.closeLoader();
                this.helperService.handleError(error);
              }
            );
        });
      })
  }

  getBridgeDetails(id):Promise<any>{
    return new Promise((res)=>{
    this.getStorage().then((_storage) => {
      let payload = {
        id: id,
      }
      this.backendService.PostAPICall('editIntBridge', payload, _storage.token).subscribe(
        async (data) => {
          let source_pp
          let operation_pp
          let payload={}
          await this.helperService.decryptpayload(data.source_params).then((decoRecords: any) => {
            this.helperService.decryptpayload(decoRecords.slice(1,decoRecords.length-1)).then((source)=>{
            source_pp = JSON.parse(atob(source.slice(1,source.length-1)));
            })
          })
          await this.helperService.decryptpayload(data.data_operations).then((decoRecords: any) => {
            operation_pp = JSON.parse(decoRecords);
          })
          if(data.source_type==1){
          for(let key of Object.keys(source_pp['input'])){
            payload['bizdata_ops_restapi']=this.generateAPISourcePayload(source_pp['input'][key],data)
          }
          }
          else if(data.source_type == 2){
            payload['bizdata_ops_jdbcsource']=source_pp['bizdata_ops_jdbcsource']
          }
          else if(data.source_type == 3){
            payload['bizdata_ops_dlakesource']=source_pp['bizdata_ops_dlakesource']
          }
          else if(data.source_type == 4){
            payload['bizdata_ops_websocketsource']=source_pp['bizdata_ops_websocketsource']
          }
          else if(data.source_type == 5){
            payload['bizdata_ops_emailsource']=source_pp['bizdata_ops_emailsource']
          }
          for(let key of Object.keys(operation_pp)){
            delete operation_pp[key].isMute;
            delete operation_pp[key].id;
            payload[key]=operation_pp[key]
          }
          let target_pp
          await this.helperService.decryptpayload(data.target_params).then(async (decoRecords: any) => {
            await this.helperService.decryptpayload(decoRecords.slice(1,decoRecords.length-1)).then((source)=>{
            target_pp = JSON.parse(atob(source.slice(1,source.length-1)));
            })
          })
        if(data.target_type==1){
            let apis=Object.keys(payload).filter((key)=>key.includes('restapi')).length;
            target_pp['input'].bizdata_rest['source']='bizdata_dataset';
            target_pp['input'].bizdata_rest['target']='bizdata_dataset';
            payload[`bizdata_ops_restapitarget_${apis+1}`]=await this.generateAPITargetPayload(target_pp['input'].bizdata_rest);
          }
          if(data.target_type==2){
            let dbs=Object.keys(payload).filter((key)=>key.includes('ops_jdbcoutput')).length;
            payload[`bizdata_ops_jdbcoutput_${dbs+1}`]=target_pp['bizdata_ops_jdbcoutput']
          }
          if(data.target_type==3){
            let dls=Object.keys(payload).filter((key)=>key.includes('ops_dlakeingestion')).length;
            payload[`bizdata_ops_dlakeingestion_${dls+1}`]=target_pp['bizdata_ops_dlakeingestion']
            payload[`bizdata_ops_dlakeingestion_${dls+1}`]['request_timeout_sec']=1000;
            payload[`bizdata_ops_dlakeingestion_${dls+1}`]['chunk_size']=500;
            payload[`bizdata_ops_dlakeingestion_${dls+1}`]['max_retries']=10;
            payload[`bizdata_ops_dlakeingestion_${dls+1}`]['queue_size']=4;
            payload[`bizdata_ops_dlakeingestion_${dls+1}`]['refresh_type']="True";
            payload[`bizdata_ops_dlakeingestion_${dls+1}`]['thread_count']=4;
          }
          if(data.target_type==4){
            let emails=Object.keys(payload).filter((key)=>key.includes('ops_email')).length;
            payload[`bizdata_ops_email_${emails+1}`]=target_pp['bizdata_ops_email']
            payload[`bizdata_ops_email_${emails+1}`]['source']='bizdata_dataset'
            payload[`bizdata_ops_email_${emails+1}`]['target']='bizdata_dataset'
          }
          res(payload)
        })
      })
    })
  }

  generateToken():Promise<any> {
    return new Promise((resolve) => {
      this.getStorage().then((res) => {
        if(res.sourceConsoleToken){
          this.checkToken().then((response)=>{
            if(response){
              resolve(res.sourceConsoleToken)
            }
            else{
              let payload = { 'type': 'data_source' };
              this.backendService.postApiTermsCall('getApiTerms', payload, res.token).subscribe(
                (data) => {
                  this.getGenerateToken('source', data['data'][0].username, data['data'][0].hashed_password).then((py_token) => {
                    // let obj = { type, py_token }
                    resolve(py_token);
                  })
                },
                (error) => {
                  //console.log(error);
                }
              );
            }
          })
        }
        else{
          let payload = { 'type': 'data_source' };
          this.backendService.postApiTermsCall('getApiTerms', payload, res.token).subscribe(
            (data) => {
              this.getGenerateToken('data_source', data['data'][0].username, data['data'][0].hashed_password).then((py_token) => {
                // let obj = { type, py_token }
                resolve(py_token);
              })
            },
            (error) => {
              //console.log(error);
            }
          );
        }
      });
    });
  }

  getGenerateToken(type, userName, password) {
    //console.log("getGenerateToken", this.consoleType)
    const payload = new FormData();
    payload.append('username', userName);
    payload.append('password', password);
    let python_base_url = environment.python_api_base_url + '/token';
    return new Promise((resolve) => {
      this.backendService.PostExternalTokenAPICall(python_base_url, payload).subscribe(
        (data) => {
          if (type == 'data_source') {
            //** USED FOR testSourceApi(), testSourceWsApi() */
            this.storage.set("pytoken_data_source", data.access_token);
          }
          resolve(data.access_token);
        },
        (error) => {
          //console.log(error);
        });
    });
  }

  async checkInvalidToken() {
    try {
      let token: string;
      token = await this.storage.get("pytoken_data_source");
      const date = this.getTokenExpirationDate(token);
      if (date === undefined) {
        return false;
      }
      return !(date.valueOf() > new Date().valueOf());
    } catch (error) {
      return true;
    }
  }

  getTokenExpirationDate(token): Date {
    const decoded = JSON.parse(atob(token.split('.')[1]));
    if (decoded.exp === undefined) {
      return null;
    }
    const date = new Date(0);
    date.setUTCSeconds(decoded.exp);
    return date;
  }

  checkToken() {
    return new Promise((resolve) => {
      this.checkInvalidToken().then(invalid => {
        if (!invalid) {
          resolve(true);
        }
        else {
          resolve(false);
        }
      })
    })
  }

  source_payload_keys = ['yesterday_str', 'source_selected_environment_name', 'user_key_url', 'source_environment_variables', 'user_key', 'rolling_time_format', 'today_str', 'rolling_frequency', 'target', 'response_parameter', 'refresh_token_url', 'refresh_token_params', 'refresh_token_method', 'refresh_token_body', 'pagination_style', 'offset_value', 'min_num', 'max_num', 'key_name_to_update', 'custom_pagination_script', 'refresh_token_headers', 'response_parameters', 'another_response_parameter'];
  generateAPISourcePayload(source_params,bridge_details){
    for(let key of this.source_payload_keys){
      source_params[key]=bridge_details.hasOwnProperty(key)?bridge_details[key]:''
    }
    for(let key of Object.keys(source_params)){
      if(key.includes('_raw')){
        let data=source_params[key]
        delete source_params.key;
        let key1=key.replace('_raw','')
        source_params[key1]=data
      }
      if(key.includes('_endpoint')){
        let data=source_params[key]
        delete source_params.key;
        let key1=key.replace('_endpoint','');
        source_params[key1]=data
      }
    }
    for(let key of Object.keys(source_params)){
      if(key=='authentication_type'){
        source_params[key]=source_params[key].type;
      }
      if(key == 'endpoint_headers'){
        source_params['endpoint_headers']=this.arrayToObject(source_params[key])
      }
      if(key == 'endpoint_params'){
          source_params['endpoint_params']=this.arrayToObject(source_params[key]);
      }
      if(key=='endpoint_method'){
        source_params[key]=source_params[key].method;
      }
      if(key=='refresh_token_method'){
        source_params[key]=source_params[key].hasOwnProperty('method')?source_params[key].method:'';
      }
      if(key=='today_str'){
        source_params[key]=`datetime.now().strftime('${source_params[key]}')`;
      }
      if(key == 'yesterday_str'){
        source_params[key]=`(datetime.now() - timedelta(1)).strftime('${source_params[key]}')`
      }
      if(key == 'target'){
        source_params[key]='bizdata_dataset'
      }
      if(key == 'authentication_type'){
        if(source_params[key]=='No Auth')
        {
          source_params[key]='no_auth'
        }
        else if(source_params[key]=='Basic Auth'){
          source_params[key]='basic_auth'
        }else
        source_params[key]=source_params[key].toLowerCase().split(' ').join('')
      }
      if(key=='endpoint_method'){
        source_params[key]=source_params[key].toLowerCase()
      }
    }
    return source_params
  }

  async generateAPITargetPayload(target_params){
    for(let key of Object.keys(target_params)){
      if(key.includes('_raw')){
        let data=target_params[key]
        let key1=key.replace('_raw','')
        target_params[key1]=data
        delete target_params.key;
      }
      if(key.includes('_endpoint')){
        let data=target_params[key]
        let key1=key.replace('_endpoint','');
        target_params[key1]=data
        delete target_params.key;
      }
    }
    for(let key of Object.keys(target_params)){
      if(key=='authentication_type'){
        target_params[key]=target_params[key].type;
      }
      if(key == 'endpoint_headers'){
        target_params['endpoint_headers']=this.arrayToObject(target_params[key])
      }
      if(key == 'endpoint_params'){
          target_params['endpoint_params']=this.arrayToObject(target_params[key]);
      }
      if(key=='endpoint_method'){
        target_params[key]=target_params[key].method;
      }
      if(key=='refresh_token_method'){
        target_params[key]=target_params[key].hasOwnProperty('method')?target_params[key].method.toLowerCase():'';
      }
      if(key == 'authentication_type'){
        if(target_params[key]=='No Auth')
        {
          target_params[key]='no_auth'
        }
        else if(target_params[key]=='Basic Auth'){
          target_params[key]='basic_auth'
        }else
        target_params[key]=target_params[key].toLowerCase().split(' ').join('')
      }
      if(key=='endpoint_method'){
        target_params[key]=target_params[key].toLowerCase()
      }
    }
    return target_params
  }

  // getInstanceDetails() {
  //   this.helperService.loader();
  //   this.getStorage().then((res) => {
  //     this.backendService.GetAPICall('getInstance', res.token).subscribe(
  //       (data) => {
  //         this.resultdata = data.instance;
  //         this.helperService.closeLoader();
  //       },
  //       (error) => {
  //         //console.log(error);
  //         this.helperService.closeLoader();
  //         this.helperService.handleError(error);
  //       }
  //     );
  //   });
  // }

  arrayToObject(arr) {
    let res={}
    for(let obj of arr){
      res[obj.key]=obj.value
    }
    return res;
  }

  stopService(id, py_conf_filename) {
    this.helperService.loader();
    this.getStorage().then((res) => {
      let payload = {
        serviceFileName: py_conf_filename + '.service',
        id
      };
      this.backendService
        .PostAPICall('stopService', payload, res.token)
        .subscribe(
          (data) => {
            this.service_status = data.statusCode;
            // this.helperService.store("status", "Stop");
            let obj = { id: id, status: "Stop" };
            this.helperService.store("status", obj);
            this.getAllIntegration();
            this.helperService.closeLoader();
            this.helperService.presentAlert("Alert!", data.msg);
          },
          (error) => {
            //console.log(error);
            this.loading = false;
            this.helperService.closeLoader();
            this.helperService.handleError(error);
          }
        );
    });
  }

  refreshService(id) {
    this.helperService.loader();
    this.getStorage().then((res) => {
      let payload = {
        id
      };
      this.backendService
        .PostAPICall('refreshService', payload, res.token)
        .subscribe(
          (data) => {
            this.service_status = data.statusCode;

            if (this.service_status == 0) {
              let obj = this.integrationDataSource.find(o => o.id === id);
              obj.service_status = 0;
            }
            if (this.service_status == 1) {
              let obj = this.integrationDataSource.find(o => o.id === id);
              obj.service_status = 1;
            }
            if (this.service_status == 2) {
              let obj = this.integrationDataSource.find(o => o.id === id);
              obj.service_status = 2;
            }
            // this.getAllIntegration();
            this.helperService.closeLoader();
            this.helperService.presentAlert("Alert!", data.msg);
          },
          (error) => {
            //console.log(error);
            this.loading = false;
            this.helperService.closeLoader();
            this.helperService.handleError(error);
          }
        );
    });
  }

  statusService(id, py_conf_filename) {
    this.helperService.loader();
    this.getStorage().then((res) => {
      let payload = {
        id,
        serviceFileName: py_conf_filename + '.service',
      };
      this.backendService
        .PostAPICall('getServiceStatus', payload, res.token)
        .subscribe(
          (data) => {
            this.service_status = data.statusCode;

            if (this.service_status == 0) {
              let obj = this.integrationDataSource.find(o => o.id === id);
              obj.service_status = 0;
            }
            if (this.service_status == 1) {
              let obj = this.integrationDataSource.find(o => o.id === id);
              obj.service_status = 1;
            }
            if (this.service_status == 2) {
              let obj = this.integrationDataSource.find(o => o.id === id);
              obj.service_status = 2;
            }
            this.helperService.closeLoader();
            this.helperService.presentAlert("Alert!", data.msg);
          },
          (error) => {
            //console.log(error);
            this.loading = false;
            this.helperService.closeLoader();
            this.helperService.handleError(error);
          }
        );
    });
  }

  async confirmClearLogsIBAlert(header, msg, id) {
    const alert = await this.alertController.create({
      header: header,
      message: msg,
      buttons: [
        {
          text: 'No',
          cssClass: 'primary-text',
          handler: () => {
            alert.dismiss();
          },
        },
        {
          text: 'Yes',
          cssClass: 'primary-text',
          handler: () => {
            this.clearlogs(id);
          },
        },
      ],
    });
    await alert.present();
  }

  confirmClearLogsIB(id) {
    const header = 'Confirm!';
    const msg = 'Are you sure you want to clear logs?';
    this.confirmClearLogsIBAlert(header, msg, id);
  }

  clearlogs(id) {
    this.helperService.loader();
    this.getStorage().then((res) => {
      let payload = {
        id
      };
      this.backendService
        .PostAPICall('clearLogs', payload, res.token)
        .subscribe(
          (data) => {
            setTimeout(() => {
              this.helperService.closeLoader();
              //console.log(data);
              this.helperService.presentToast(data.msg, 3000);
              // let file_name = data.msg;
              // let path = environment.download_path + '/' + file_name;
              // let pwa = window.open(path);
              // if (!pwa || pwa.closed || typeof pwa.closed == 'undefined') {
              //   this.helperService.presentAlert('Alert!', 'Please disable your Pop-up blocker and try again');
              // } else {
              //   this.helperService.presentToast('Log downloaded successfully', 2000);
              // }
            },
              1000);
          },
          (e) => {
            //console.log(err);
            this.loading = false;
            this.helperService.closeLoader();
            this.helperService.handleError(e);
          }
        );
    });
  }

  downloadLogs(id) {
    this.helperService.loader();
    this.getStorage().then((res) => {
      let payload = {
        id
      };
      this.backendService
        .PostAPICall('downloadLogs', payload, res.token)
        .subscribe(
          (data) => {
            setTimeout(() => {
              this.helperService.closeLoader();
              let file_name = data.msg;
              let path = environment.download_path + '/' + file_name;
              let pwa = window.open(path);
              if (!pwa || pwa.closed || typeof pwa.closed == 'undefined') {
                this.helperService.presentAlert('Alert!', 'Please disable your Pop-up blocker and try again');
              } else {
                this.helperService.presentToast('Log downloaded successfully', 2000);
              }
            },
              10000);
          },
          (error) => {
            //console.log(error);
            this.loading = false;
            this.helperService.closeLoader();
            this.helperService.handleError(error);
          }
        );
    });
  }
  downloadLogFile(id) {
    this.helperService.loader();
    this.getStorage().then((res) => {
      let payload = {
        id
      };
      this.backendService
        .PostAPICall('downloadEncodedFile', payload, res.token)
        .subscribe(
          (data) => {
            this.helperService.closeLoader();
            // let ss = atob(data.data).split(".log")[0];
            // let xs = ss.split("_");
            // //console.log(ss, xs);
            
            let file = new File([Uint8Array.from(atob(data.data), (m) => m.codePointAt(0))], '',{ type: "zip" });
            var a = document.createElement("a"); //Create <a>
            var blob = new Blob([file], {'type':"application/zip"});
            a.href = URL.createObjectURL(blob);
            a.download = data.filename+".zip"; //File name Here
            a.click(); //Downloaded file
          },
          (error) => {
            //console.log(error);
            this.loading = false;
            this.helperService.closeLoader();
            this.helperService.handleError(error);
          }
        );
    });
  }
  loadMore(event) {
    //console.log("check if its working")
    this.helperService.loader();
    // this.page_min = this.page_max;
    this.page_max = this.page_max + 10;
    let payload = {
      min: this.page_min,
      max: this.page_max,
      sort: this.sortBy,
      order: this.orderBy,
      updatedDate_sort: this.updatedDate_sortBy,
      updatedDate_order: this.updatedDate_orderBy,
      q: this.search,
    };
    this.getStorage().then((res) => {
      this.backendService
        .PostAPICall('getAllIntBridge', payload, res.token)
        .subscribe(
          async (data) => {
            this.helperService.closeLoader();
            await this.helperService.decryptpayload(data.records).then((res)=>{
              // this.integrationDataSource = data.records
              this.integrationDataSource = JSON.parse(res);
              if(this.selectExportAllIB == true){
                this.ibselection.clear();
                for(let i=0;i<=this.integrationDataSource.length-1;i++){
                  for(let j=0;j<=this.selectedIB.length-1;j++){
                    if(this.integrationDataSource[i].id == this.selectedIB[j].id){
                      this.ibselection.select(this.integrationDataSource[i]);
                    }
                  }
                }              }
            });
            // this.integrationDataSource = data.records;
            event.target.complete();
            if (data.records.length == this.totalIntegration) {
              event.target.disabled = true;
            }
            // for(let i of this.wsData){
            //   this.integrationDataSource.find(v => {
            //     if(v.id === i.ib_id && v.service_status !== i.data){
            //       v.service_status = i.data;
            //     }
            //   })
            // }
            
          },
          (error) => {
            //console.log(error);
            event.target.complete();
            this.helperService.closeLoader();
            this.helperService.handleError(error);
          }
        );
    });
  }

  searchStringMethod(message: string) {
    this.incomingSearchText$.next(message);
  }

  clearSearch() {
    this.search = '';
    this.searchStringMethod(this.search);
  }

  getSearchOnChange(e) {
    this.searchStringMethod(e);
  }

  async getStorage() {
    let data = {
      token: await this.storage.get("token"),
      userId: await this.storage.get("id"),
      showDialog: await this.storage.get("showDialog"),
      freeTrailMode: await this.storage.get("free_trial_mode"),
      mileStoneTokenConsole: await this.storage.get("milestonetoken_console"),
      sourceConsoleToken: await this.storage.get('pytoken_data_source')
    }
    return data;
  }

  // toggleInfiniteScroll() {
  //   this.infiniteScroll.disabled = !this.infiniteScroll.disabled;
  // }

  editIntegration(id) {
    this.router.navigate(['baseapp/integration/update', btoa(id)]);
    // this.router.navigate(['baseapp/integration/update', id]);
  }

  getIntegrationDetails(id) {
    this.router.navigate(['baseapp/integration/details', btoa(id)]);
  }

  confirmDelete(userId) {
    const header = 'Confirm!';
    const msg = 'Are you sure you want to delete?';
    this.confirmDeleteAlert(header, msg, userId);
  }

  deleteIntegration(id) {
    this.helperService.loader();
    this.getStorage().then((res) => {
      let url = `/api/integrationBridge/deleteIntBridge/${id}`;
      this.backendService.DeleteAPICall(url, res.token).subscribe(
        (res) => {
          this.helperService.closeLoader();
          this.helperService.presentToast(res.msg, 2000);
          this.getAllIntegration();
        },
        (error) => {
          //console.log(error);
          this.helperService.handleError(error);
              this.helperService.closeLoader();
        }
      );
    });
  }

  closebubblecross() {
    this.bubbleshow = false;
  }

  closebubble() {
    this.bubbleshow = false;
  }

  addIntegration() {
    this.getStorage().then((storage_date) => {
      // this.helperService.closeLoader();
      if (storage_date.freeTrailMode) {
        if (this.totalIntegration == 0) {
          this.router.navigate(['baseapp/integration/create']);
        } else {
          this.helperService.presentAlert('Information', 'You can create only one integration bridge as a free trail user. Please subscribe to create more integration bridge.')
        }
      } else {
        this.getSubscriptionDetails().then((plan_details: any) => {
          // //console.log(plan_details);
          // let plan_details = {plan_name: 'month', qty_purchased: 3, qty_utilized: 0, qty_remaining: 0}
          if (plan_details.qty_remaining == 0) {
            this.helperService.presentAlert('Information', 'Your limit has exceeded. Please upgrade your plan to create more integration bridge.')
          } else {
            this.router.navigate(['baseapp/integration/create']);
          }
        });
      }
    })
  }

  getSubscriptionDetails() {
    // this.helperService.loader();
    return new Promise((resolve) => {
      this.getStorage().then((storage_date) => {
        let payload = {
          user_id: storage_date.userId
        };
        this.backendService
          .PostAPICall('getPlanDetails', payload, storage_date.token)
          .subscribe(
            (data) => {
              // //console.log(data);
              resolve(data);
              // this.helperService.closeLoader();
              // this.integrationDataSource = data.records;
            },
            (error) => {
              //console.log(error);
            }
          );
      });
    })
  }

  streamingLogs(id, name, status) {
    let obj = {}
    if (status == 0 || status == 2) {
      obj = { id: id, status: "Stop" };
      this.helperService.store("status", obj);
    } else {
      obj = { id: id, status: "Start" };
      this.helperService.store("status", obj);
    }
    //console.log(this.helperService.getStorage());
    let objLog = {
      id: id,
      name: name
    };
    let streamObjLog = btoa(JSON.stringify(objLog));
    //console.log(streamObjLog);
    this.router.navigate([]).then(result => { window.open("#/baseapp/integration/stream-logs/" + streamObjLog); });
  }

  sortColumn(sortState: Sort) {
    // //console.log(sortState);
    // this.helperService.loader();
    this.currentState = sortState.active;
    this.sortBy = 'service_status';
    this.updatedDate_sortBy = 'updated_date';
    if (sortState.active == 'status') {
      // this.sortBy = 'service_status';
      if (sortState.direction == 'asc') {
        this.orderBy = 'ASC';
      }
      if (sortState.direction == 'desc') {
        this.orderBy = 'DESC';
      }
    }
    if (sortState.active == 'updated_date') {
      // this.updatedDate_sortBy = 'updated_date';
      if (sortState.direction == 'asc') {
        this.updatedDate_orderBy = 'ASC';
      }
      if (sortState.direction == 'desc') {
        this.updatedDate_orderBy = 'DESC';
      }
    }
    this.getAllIntegration();
  }

  onFileSelect(event) {
    const file: File = event.target.files[0];
    // Check file extension and MIME type
    const fileExtension = file.name.split('.').pop().toLowerCase();
    const mimeType = file.type;
    if (fileExtension !== 'ez') {
      this.helperService.presentToast("Please upload a valid file", 2000);
      return;
    }
  
    this.importFile = file;
    this.getStorage().then(async (res)=>{
      await this.helperService.loader();
      const form: FormData = new FormData();
      form.append("IBFile", this.importFile);
      this.backendService.PostInstanceAPICall('importIB', form, res.token).subscribe(
      (data) => {
        if(data.msg.successfully_imported_ib != undefined){
          if(data.msg?.successfully_imported_ib.length != 0) {
            this.helperService.presentToast("IB import successful", 2000);
          }
        } else {
          this.helperService.presentToast(data.msg, 2000);
        }       
        
        this.helperService.closeLoader();
        this.getAllIntegration();
      },(error)=>{
        this.helperService.closeLoader();
        this.helperService.handleError(error);
      })
    })
    
  }

  checkIsAllIBSelected() {
    const numSelected = this.ibselection.selected.length;
    const numRows = this.integrationDataSource.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  selectAllIB(eve?) {
    if(!eve.checked){
      this.selectExportAllIB = false;
      this.selectedIB = [];
    }else{
      this.selectExportAllIB = true;      
    }    
    this.checkIsAllIBSelected() ?
        this.ibselection.clear() :
        this.integrationDataSource.forEach(row => this.ibselection.select(row));
        this.selectedIB = this.ibselection.selected;
  }

  exportIB() {
    let ibselected = [];
      this.ibselection.selected.forEach(s =>{
        ibselected.push(s.id);
      });
      if(ibselected.length > 0) {
        this.getStorage().then(async (res)=>{
          await this.helperService.loader();
          let payload= {
            "id": ibselected
          };
          this.backendService.PostAPICall('exportIB', payload, res.token).subscribe((data) => {
            if(data?.msg !== undefined){
              this.helperService.closeLoader();
              this.helperService.presentToast(data.msg, 2000);
              return
            }
            let base64String = data.data;
            let fileName = data.file_name;
            this.helperService.closeLoader();
            let encrypted = '';
            for (let i = 0; i < data.data.length; i++) {
              encrypted += String.fromCharCode(data.data.charCodeAt(i) ^ 123);
            }
            
            const blob = new Blob([encrypted], { type: 'text/plain' });
            const link = document.createElement('a');
            link.href=URL.createObjectURL(blob);
            link.download = fileName+'.ez';
            // link.href = window.URL.createObjectURL(blob);
            // document.body.appendChild(link);
            link.click();
            // document.body.removeChild(link);
            URL.revokeObjectURL(link.href);
            this.ibselection.clear();
            this.selectedIB = [];
            this.selectExportAllIB = false;

          },
          (error) => {
            //console.log(error);
            this.loading = false;
            this.helperService.closeLoader();
            this.helperService.handleError(error);
          })      
        })
      } else {
        this.helperService.presentToast("Please select products", 2000);      
      }
  }
  
  // getServiceStatusWS(){
  //   this.getStorage().then((res) => {
  //     getServiceStatus(res.token, 'start');
  //       this.intervalSubscription = interval(30000).subscribe(() => {
  //         this.wsData.length = 0;
  //         getServiceStatus("", "close");
  //         getServiceStatus(res.token, 'start');
  //       });
  //   })   
  // }
  ngOnDestroy(): void {
    // this.wsData = [];
    // this.intervalSubscription.unsubscribe();
    // getServiceStatus("", "close");
  }
}